"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActivityController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const apiPath = endpoints_1.endpoints.userActivity;
const userActivityController = (service) => ({
    readAll: () => {
        return service.get(apiPath, service.addAccessTokenToHeaders);
    },
});
exports.userActivityController = userActivityController;
